import axios from "axios";

export const createProduct = async (data: any) =>
  await axios.post("/product/", data);

export const updateProduct = async (productId: string, data: any) =>
  await axios.patch(`/product/${productId}`, data);

export const getProduct = async () => await axios.get("/product");

export const deleteProduct = async (pid: string) =>
  await axios.delete(`/product/${pid}`);
